import { Store } from '../../../store/player/types';

/**
 * Hide force playback tooltip
 */
export const hideForcePlaybackTooltip = (store: Store): void => {
  const { setIsForcingPlayback } = store.getState();
  setIsForcingPlayback(false);
};
